import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUserSearches } from '../api/api';

const initialState = {
  savedSearches: [],
  loading: false,
  error: null
};

export const fetchSavedSearches = createAsyncThunk(
  'savedSearches/fetchSavedSearches',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchUserSearches();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch saved searches');
    }
  }
);

const savedSearchesSlice = createSlice({
  name: 'savedSearches',
  initialState,
  reducers: {
    clearSavedSearches: (state) => {
      state.savedSearches = [];
    },
    addSavedSearch: (state, action) => {
      state.savedSearches.push(action.payload);
    },
    removeSavedSearch: (state, action) => {
      state.savedSearches = state.savedSearches.filter(search => search.id !== action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedSearches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavedSearches.fulfilled, (state, action) => {
        state.savedSearches = action.payload;
        state.loading = false;
      })
      .addCase(fetchSavedSearches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearSavedSearches, addSavedSearch, removeSavedSearch } = savedSearchesSlice.actions;
export default savedSearchesSlice.reducer; 